module.exports = __webpack_public_path__ + "static/img/training-6.14c1ce4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/KishoreTraining/Kishore-pics/training-6.jpg
// module id = I08b
// module chunks = 0